import useModuleMetadata from 'src/hooks/use-module-metadata.hook';
import { Checkbox, Grid, Button } from '@mui/material';
import StarRateIcon from '@mui/icons-material/StarRate';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { CreateNewScenarioDialog } from '../home/components';
import { getAccessConfigForScenario } from '../home/store/simulator-home-async-thunks';
import { setScenario } from '../home/store/simulator-home-slice';
import MODULE_TO_PAGE_MAP from '../home/types/simulation-module-to-page-map';
import { CHECKBOX_VALUES } from '../pricing-simulator/types/generic-table.model';
import { Scenario } from '../scenarios/types/scenario.model';
import './scenario-manager.scss';
import ScenarioManagerSearchTopBar from './search-top-bar';
import { handleCheckboxValueChange } from './store/scenario-manager-top-bar-slice';

export default function ScenarioManagerTopBar({
  isNewScenarioBtnPresent
}: {
  isNewScenarioBtnPresent: boolean;
}) {
  const appDispatch = useAppDispatch();
  const { activeCheckboxValues } = useAppSelector(
    (state) => state.scenarioManagerTopBar
  );
  const navigate = useNavigate();
  const [isNewScenarioDialogOpen, setIsNewScenarioDialogOpen] = useState(false);
  const checkBoxValues: {
    name: string;
    value: CHECKBOX_VALUES;
    checked: boolean;
  }[] = [
      {
        name: 'Active + Finalized',
        value: CHECKBOX_VALUES.IS_ACTIVE_FINALIZED,
        checked: true
      },
      {
        name: 'Finalized',
        value: CHECKBOX_VALUES.IS_FINALIZED,
        checked: false
      },
      {
        name: 'Archived',
        value: CHECKBOX_VALUES.IS_ARCHIVED,
        checked: false
      }
    ];

  const { sourceId } = useModuleMetadata({
    module: MODULE_TO_PAGE_MAP.PLANNER
  });

  const createScenarioClickHandler = () => {
    setIsNewScenarioDialogOpen(true);
  };

  const scenarioFormSubmitHandler = (scenario: Scenario) => {
    setIsNewScenarioDialogOpen(false);
    if (scenario) {
      appDispatch(setScenario(scenario));
      appDispatch(
        getAccessConfigForScenario({ scenarioId: scenario.pk_id, sourceId })
      ).then(() =>
        navigate(`/srm/simulator/${scenario.pk_id}/planner?showSuccess=true`)
      );
    }
  };

  const handleValueChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
    checkboxData: { name: string; value: CHECKBOX_VALUES }
  ) => {
    appDispatch(
      handleCheckboxValueChange({
        name: checkboxData.value,
        checked
      })
    );
  };

  return (
    <>
      <Grid
        container
        spacing={1}
        alignItems='center'
        justifyContent='space-between'
        sx={{ marginBottom: '20px' }}
      >
        <Grid item md={6}>
          <div>
            {checkBoxValues.map((data) => (
              <span
                style={{ marginRight: '5px' }}
                className={`${activeCheckboxValues.includes(data.value)
                    ? 'active-checkbox scenario-manager-checkbox'
                    : 'scenario-manager-checkbox'
                  }`}
              >
                <Checkbox
                  onChange={(e, checked) => handleValueChange(e, checked, data)}
                  defaultChecked={data.checked}
                  sx={{ '&.MuiCheckbox-root': { p: 0.5 } }}
                  size='small'
                />
                {data.name}
              </span>
            ))}
          </div>
        </Grid>
        <Grid item xs sx={{ textAlign: 'right' }}>
          <Grid
            container
            spacing={1}
            alignItems='center'
            justifyContent='right'
          >
            <Grid>
              <div style={{ padding: '11px 7px 0 0' }}>
                <StarRateIcon sx={{ fontSize: '20px', color: '#0000a0' }} />
              </div>
            </Grid>
            <Grid mr={1}>
              <div className='finalized-scenario-label'>Favorite Scenarios</div>
            </Grid>
            <Grid>
              <div style={{ padding: '11px 7px 0 0' }}>
                <img
                  src='/static/icons/finalized-scenario.svg'
                  alt='finalized'
                />
              </div>
            </Grid>
            <Grid>
              <div className='finalized-scenario-label'>
                Finalized Scenarios
              </div>
            </Grid>
            <Grid item xs={6}>
              <ScenarioManagerSearchTopBar />
            </Grid>
            {isNewScenarioBtnPresent && (
              <Grid>
                <Button
                  sx={{ ml: 1, mt: '7px' }}
                  variant='contained'
                  onClick={createScenarioClickHandler}
                >
                  + New Scenario
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      {isNewScenarioDialogOpen ? (
        <CreateNewScenarioDialog
          isEditable={false}
          isDuplicate={false}
          currentScenario={null}
          isOpen={isNewScenarioDialogOpen}
          onClose={scenarioFormSubmitHandler}
        />
      ) : null}
    </>
  );
}
